import React, { useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import useDeviceDetection from '../../hooks/useDeviceDetection';
import { Wrapper, ArrowButton, SliderContainer } from './CardsSlider.styles';
import ArrowIcon from '../../icons/ArrowIcon';
import VerticalCard from '../CardVertical/VerticalCard';

const CardsSlider = ({ items }) => {
  const { isMobile, isTablet, isDesktop } = useDeviceDetection();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [sliderRef, instanceRef] = useKeenSlider({
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    created() {
      setLoaded(true);
    },
    loop: false,
    slides: {
      perView: '1.1',
      spacing: 30,
    },
    breakpoints: {
      '(min-width: 769px)': {
        slides: {
          perView: '2.3',
          spacing: 60,
        },
      },
      '(min-width: 1024px)': {
        slides: {
          perView: '3',
          spacing: 60,
        },
      },
    },
  });

  const isArrowDisabled =
    (items.length < 3 && isDesktop) || (items.length < 2 && isTablet) || (items.length === 1 && isMobile);

  const getVisibleSlides = () => {
    if (isMobile) {
      return 1;
    }
    if (isTablet && !isDesktop) {
      return 2;
    }
    return 3;
  };

  function Arrow({ left, onClick, disabled }) {
    const disabeld = disabled ? ' disabled' : '';
    return (
      <ArrowButton onClick={onClick} className={`arrow ${left ? 'left' : 'right'} ${disabeld}`} type="button">
        <ArrowIcon />
      </ArrowButton>
    );
  }

  return (
    <SliderContainer>
      <Wrapper>
        <div className="navigation-wrapper">
          <div ref={sliderRef} className="keen-slider">
            {items &&
              items.map(item => (
                <VerticalCard
                  key={item?.id}
                  image={item?.image}
                  title={item?.title}
                  subtitle={item?.subTitle}
                  cta={item?.linkTitle}
                  ctaUrl={item?.ctaUrl}
                  className={`keen-slider__slide `}
                />
              ))}
          </div>

          {loaded && instanceRef.current && (
            <>
              <Arrow
                type="button"
                left
                onClick={e => e.stopPropagation() || instanceRef.current?.prev()}
                disabled={currentSlide === 0 || isArrowDisabled}
              />

              <Arrow
                type="button"
                onClick={e => e.stopPropagation() || instanceRef.current?.next()}
                disabled={
                  currentSlide === instanceRef.current.track.details.slides.length - getVisibleSlides() ||
                  isArrowDisabled
                }
              />
            </>
          )}
        </div>
      </Wrapper>
    </SliderContainer>
  );
};

export default CardsSlider;
